module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "home"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'newsfeed'
      }
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/news.jpg"),
      "alt": "$t('categories.news')"
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.news')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'reviews'
      }
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/reviews.jpg"),
      "alt": _vm.$t('categories.reviews')
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.reviews')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'interviews'
      }
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/interviews.jpg"),
      "alt": _vm.$t('categories.interviews')
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.interviews')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'releases'
      }
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/releases.jpg"),
      "alt": _vm.$t('categories.releases')
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.releases')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'events'
      }
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/events.jpg"),
      "alt": _vm.$t('categories.events')
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.events')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'encyclopedia'
      }
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/encyclopedia.jpg"),
      "alt": _vm.$t('categories.encyclopedia')
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.encyclopedia')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'http://www.spirit-of-metal.com/forum/index.php?l=' + this.$i18n.locale,
      "title": "Forums"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../../assets/img/jpg/forums.jpg"),
      "alt": _vm.$t('categories.forums')
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(_vm.$t('categories.forums')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-740d1dc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/Home.vue
// module id = 269
// module chunks = 0